import type { IconData } from '@stacksjs/iconify-core'

export const rssSquareSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.18 46.914c3.412.283 8.91.586 16.82.586s13.408-.303 16.82-.586c3.285-.273 5.82-2.809 6.093-6.094c.284-3.412.587-8.91.587-16.82s-.303-13.408-.586-16.82c-.273-3.285-2.809-5.82-6.094-6.094C37.408.803 31.91.5 24 .5s-13.408.303-16.82.586C3.895 1.36 1.36 3.895 1.086 7.18C.803 10.592.5 16.09.5 24s.303 13.408.586 16.82c.273 3.285 2.809 5.82 6.094 6.093M10.5 10.5a3 3 0 0 1 3-3c14.912 0 27 12.088 27 27a3 3 0 1 1-6 0c0-11.598-9.402-21-21-21a3 3 0 0 1-3-3m0 12a3 3 0 0 1 3-3c8.284 0 15 6.716 15 15a3 3 0 1 1-6 0a9 9 0 0 0-9-9a3 3 0 0 1-3-3m-1 12a4 4 0 1 1 8 0a4 4 0 0 1-8 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default rssSquareSolid
